import React from "react";
import { Link } from "react-router-dom";
import { Avatar, Box, Button, Chip, IconButton, LinearProgress, TableCell, TableRow, Tooltip, Typography } from "@material-ui/core";
import {
  CheckCircleOutline, HourglassEmpty, MoreHoriz, PermIdentityOutlined,
  PhoneOutlined, TimerOffOutlined, VisibilityOutlined,
} from "@material-ui/icons";
import useStyles from "@jumbo/Dashboards/FormBuilder/recordListStyles";
import { dateText, statuses } from "./utils";

const statusIcons = {
  inProgress: <HourglassEmpty />, submitted: <CheckCircleOutline />, expired: <TimerOffOutlined />,
};

export default function TicketListItem({ ticket, formId, inputsUrl, privacyMode, name, saving, mobile, onMenu }) {
  const classes = useStyles();
  const saved = ticket.answerCount || 0;
  const total = ticket.questionCount || 0;
  const progress = total ? Math.max(0, Math.min(100, saved / total * 100)) : 0;
  const participant = <Box className={classes.participant}>
    <Avatar className={classes.avatar} aria-hidden="true">{name.trim().charAt(0)}</Avatar>
    <Box>
      <Typography component="span" className={classes.participantName}>{name}</Typography>
      <Typography component="span" className={classes.secondary}>کد پرسنلی: <bdi>{ticket.owner?.personnelCode || "—"}</bdi></Typography>
    </Box>
  </Box>;
  const contact = <Box className={classes.contact}>
    <Typography component="p" variant="body2"><PermIdentityOutlined /><span className={classes.digits} dir="ltr" title="کد ملی">{privacyMode ? "—" : ticket.owner?.nationalCode || "—"}</span></Typography>
    <Typography component="p" variant="body2"><PhoneOutlined /><span className={classes.digits} dir="ltr" title="شماره تماس">{privacyMode ? "—" : ticket.owner?.phone || "—"}</span></Typography>
  </Box>;
  const status = <Chip icon={statusIcons[ticket.status]} className={`${classes.status} ${classes[ticket.status] || ""}`} label={statuses[ticket.status]} />;
  const answers = <Box className={classes.progress}>
    <Typography className={classes.progressLabel}>{saved.toLocaleString("fa-IR")} از {total.toLocaleString("fa-IR")} سوال</Typography>
    <LinearProgress aria-label={`پاسخ‌های ذخیره‌شده ${name}`} variant="determinate" value={progress}
      className={`${classes.progressTrack} ${progress === 100 ? classes.progressComplete : ""}`} />
    <Typography component="span" className={classes.secondary}>پاسخ ذخیره‌شده</Typography>
  </Box>;
  const timing = <Box className={classes.timing}>
    <Box><Typography component="span" className={classes.secondary}>شروع آزمون</Typography><Typography component="span" className={classes.timeValue}>{dateText(ticket.createdAt)}</Typography></Box>
    <Box><Typography component="span" className={classes.secondary}>مهلت پاسخگویی</Typography><Typography component="span" className={classes.timeValue} color={ticket.status === "expired" ? "error" : "textPrimary"}>
      {ticket.durationEnabled ? dateText(ticket.expiresAt) : "بدون محدودیت زمانی"}
    </Typography></Box>
  </Box>;
  const actions = <Box className={classes.actions}>
    <Button component={Link} variant="outlined" color="primary" size="small" startIcon={<VisibilityOutlined />} className={classes.viewButton}
      to={ticket.status === "submitted" ? ticket.formFilled ? `/formFillDetails/${ticket.formFilled}` : inputsUrl : `/formtickets/${formId}/${ticket._id}/answers`}>
      نمایش پاسخ
    </Button>
    {ticket.status !== "submitted" && <Tooltip title="عملیات بلیط">
      <IconButton className={classes.moreButton} aria-label={`عملیات بلیط ${name}`} aria-haspopup="menu" disabled={saving} onClick={event => onMenu(event, ticket)}>
        <MoreHoriz />
      </IconButton>
    </Tooltip>}
  </Box>;

  if (mobile) return <Box component="article" aria-label={`بلیط ${name}`} className={classes.mobileCard}>
    <Box className={classes.mobileCardHeader}>{participant}{status}</Box>
    <Box className={classes.mobileCardBody}>{answers}{contact}{timing}</Box>
    <Box className={classes.mobileCardFooter}>{actions}</Box>
  </Box>;

  return <TableRow>
    <TableCell>{participant}</TableCell>
    <TableCell>{contact}</TableCell>
    <TableCell>{status}</TableCell>
    <TableCell>{answers}</TableCell>
    <TableCell>{timing}</TableCell>
    <TableCell>{actions}</TableCell>
  </TableRow>;
}
